import { render, staticRenderFns } from "./PartGoodReceiptDetailUpload.vue?vue&type=template&id=8af8c0f2&"
import script from "./PartGoodReceiptDetailUpload.vue?vue&type=script&lang=js&"
export * from "./PartGoodReceiptDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports